import Cookies from 'js-cookie';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = actions;

const login = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/auth/login', values);
      // console.log(response);
      // console.log(values);
      if (response.data.throw) {
        console.log(response.data.throw.message);
        const err = response.data.throw.message;
        dispatch(loginErr(err));
      }
      if (!response.data.throw) {
        console.log(response.data);
        Cookies.set('access_token', response.data.access_token);
        Cookies.set('logedIn', true);
        // console.log('User Data', response.data.user);
        Cookies.set('FirstName', response.data.user.FirstName);
        Cookies.set('LastName', response.data.user.LastName);
        Cookies.set('NationalId', response.data.user.NationalId);
        Cookies.set('Role', response.data.user.Role);
        Cookies.set('Designation', response.data.user.Designation);
        dispatch(loginSuccess(true));
        callback();
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const register = (values) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/register', values);
      if (response.data.errors) {
        dispatch(loginErr('Registration failed!'));
      } else {
        dispatch(loginSuccess(false));
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      Cookies.remove('logedIn');
      Cookies.remove('access_token');
      Cookies.remove('FirstName');
      Cookies.remove('LastName');
      Cookies.remove('NationalId');
      Cookies.remove('Role');
      Cookies.remove('Designation');
      dispatch(logoutSuccess(false));
      callback();
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut, register };
